module.exports = __webpack_public_path__ + "static/media/polyIcon.959c3843.png";